// extracted by mini-css-extract-plugin
module.exports = {"textarea":"FeedbackDialog_textarea__u5cut","thankYouDialog":"FeedbackDialog_thankYouDialog__3e-mi"};